import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import adaptedImageUrl, { BASE_URL } from '../config';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { LOCAL_STORAGE } from "../context/LocalStorage";
import DataTableExtensions from "react-data-table-component-extensions";
import DashboardDetails from "./Dashboard/DashboardDetails";
import fetchWrapper from "../utils/fetch/fetchWrapper";

export default function Dashboard() {
    const [data, setData] = useState([]);
    const MySwal = withReactContent(Swal)
    const [showModal, setShowModal] = useState(false);
    const [idRowSelected, setIdRowSelected] = useState(null);

    const fetchData = (event) => {
        fetchWrapper()
          .doGet({
              url: "/api/v1/dashboard",
              onSuccess: async (response) => {
                  setData(response.data.region)
              },
              onError: (response) => {
                  alert(response.data.message);
              },
              })
              .then(() => {
              })
              .catch((error) => {
              });
    }

    useEffect(() => {
        fetchData()
    }, []);


    const CustomImage = ({ row }) => (
        <div>
            <img height="50px" width="50px" className="w-full  align-middle border-none shadow-lg"
                src={adaptedImageUrl(row.avatar_url) ?? null} />
        </div>
    );

    const editModal = (id) => {
        setIdRowSelected(id)
        setShowModal(true)
    }

    const columns = [
        
        {
            name: "Region",
            selector: "name",
            sortable: true,
        },
        {
            name: "Usuarios",
            selector: "user",
            sortable: true,
        },
        {
            name: "Ventas",
            cell: row => <>{new Intl.NumberFormat('de-DE').format(row.sales)}</>,
            sortable: true,
        },
        {
            name: 'Ver detalle',
            cell: row => <a onClick={() => editModal(row.id)}><i class="fas fa-eye"></i></a>,
        },
    ];

    const tableData = {
        columns,
        data
    };
    return (
        <>
            <DashboardDetails
                showModal={showModal}
                setShowModal={setShowModal}
                id={idRowSelected}
                setId={setIdRowSelected}
                fetchData={fetchData}
            />
            <div className="row">
                <h1>Seifrei</h1>
            </div>
            <DataTableExtensions {...tableData}>

                <DataTable
                    columns={columns}
                    data={data}
                    pagination
                    paginationPerPage={10}
                />
            </DataTableExtensions>

        </>
    );
}
